import { render, staticRenderFns } from "./overhead-desktop.vue?vue&type=template&id=e01ab208&"
import script from "./overhead-desktop.vue?vue&type=script&lang=js&"
export * from "./overhead-desktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports